<se-fe-card class="org-card" id="orgCard">
  <se-fe-card-header [seFeDataTitle]="cardTitle()" [seFeDataHeavyBorder]="true">
    @if (editable()) {
      <div seFeCardHeaderActions>
        <item-org-modal
          class="item-detail-modal"
          id="edit-modal"
          [vendor]="{brand: brandName() || '', name: vendorName() || '', taxCode: taxCode() || ''}"
          [catalogs]="organizationCatalogs()"
          [catalogsLoading]="organizationCatalogsLoading()"
          [catalogsOnly]="catalogsOnly()"
          [selectedCatalogIds]="selectedCatalogIds()"
          (catalogsRequested)="onOrganizationCatalogsRequested()"
          (updateBrand)="onUpdateProductBrand($event)"></item-org-modal>
      </div>
    }
  </se-fe-card-header>
  <se-fe-card-content id="item-detail__product-org">
    <se-fe-grid seFeGridOpts="snug">
      <se-fe-grid-cell id="item-detail__brand" seFeGridOpts>
        <se-fe-form-field [seFeDataConfig]="disabledFields() ? productBrands : productBrand()">
          @if (disabledFields()) {
            <ng-container [formGroup]="disabledFieldsForm">
              <se-fe-form-field-text formControlName="brands"></se-fe-form-field-text>
            </ng-container>
          }
        </se-fe-form-field>
        @if (!disabledFields()) {
          <p class="org-card__field-value">{{ products() !== undefined ? computedBrands() : brandName() || '--' }}</p>
        }
        @if (products() !== undefined) {
          <se-fe-form-control-help>
            The brands of the products in your bundle will automatically display here
          </se-fe-form-control-help>
        }
      </se-fe-grid-cell>
    </se-fe-grid>
    <se-fe-grid seFeGridOpts="snug">
      <se-fe-grid-cell id="item-detail__vendor" seFeGridOpts>
        <se-fe-form-field [seFeDataConfig]="productVendor">
          @if (disabledFields()) {
            <ng-container [formGroup]="disabledFieldsForm">
              <se-fe-form-field-text formControlName="vendor"></se-fe-form-field-text>
            </ng-container>
          }
        </se-fe-form-field>
        @if (!disabledFields()) {
          <p>{{ vendorName() || '--' }}</p>
        }
        @if (vendorName()) {
          <se-fe-form-control-help>
            You can't change this because your organization is the seller of this product
          </se-fe-form-control-help>
        }
      </se-fe-grid-cell>
    </se-fe-grid>
    @if (taxCode() !== undefined) {
      <se-fe-grid seFeGridOpts="snug">
        <se-fe-grid-cell id="item-detail__tax-code" seFeGridOpts>
          <se-fe-form-field [seFeDataConfig]="productTaxCode"></se-fe-form-field>
          <p class="org-card__field-value">{{ taxCode() || '--' }}</p>
        </se-fe-grid-cell>
      </se-fe-grid>
    }
    <se-fe-grid seFeGridOpts="snug">
      <se-fe-grid-cell id="item-detail__catalogs" seFeGridOpts>
        <se-fe-form-field [seFeDataConfig]="productCatalogs"></se-fe-form-field>
        @if (catalogsLoading()) {
          <se-fe-spinner [seFeDataCenter]="true"></se-fe-spinner>
        } @else {
          @for (catalog of catalogs(); track catalog.id) {
            <p class="org-card__field-value">
              <a
                class="org-card__catalog-link"
                target="_blank"
                [routerLink]="['/org', organizationId(), 'commerce', 'catalogs', catalog.id]">
                {{ catalog.name }}
              </a>
            </p>
          } @empty {
            <p class="org-card__field-value">--</p>
          }
        }
      </se-fe-grid-cell>
    </se-fe-grid>
  </se-fe-card-content>
</se-fe-card>
